import type { GarmentGeometryComponent, IScene } from '@seddi/scene';
import type { FileLoader } from '@seddi/ui-babylon-core';
import * as Scene from '../scene/scene';
import * as SceneModule from '../scene/sceneModule';
import { GarmentGeometryLoader } from './garmentGeometryLoader';

export class EcGarmentGeometryLoader {
  private readonly garmentGeometryLoader: GarmentGeometryLoader;

  constructor(fileLoader: FileLoader) {
    this.garmentGeometryLoader = new GarmentGeometryLoader(fileLoader);
  }

  async loadAsync(scene: IScene, component: GarmentGeometryComponent): Promise<void> {
    const hasGeometry = Scene.hasGeometrySurface(scene);
    if (!hasGeometry) {
      return;
    }
    // Fetch garment geometry
    const surfaceUrl = component.surfaceUrl!;
    const garmentGeometry = await this.garmentGeometryLoader.loadAsync(scene, surfaceUrl);
    SceneModule.sceneExt.garmentGeometry = garmentGeometry;
  }

  unload(_component: GarmentGeometryComponent) {
    SceneModule.sceneExt.garmentGeometry = undefined;
  }
}
